import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.less';
import Button from '../Button';
import { PaymentMethodsEnum } from './payment-methods-enum';

const paymentSubtypes = [
  {
    key: 'visa',
    title: 'Visa',
    image: '/static/images/course/visa2.png',
  },
  {
    key: 'mastercard',
    title: 'Mastercard',
    image: '/static/images/course/master2.png',
  },
  {
    key: 'arca',
    title: 'Arca',
    image: '/static/images/course/arca2.png',
  },
];

const ArcaPayment = ({ orderCourse, orderLoading }) => (
  <div className={styles.paymantContainer}>
    {paymentSubtypes.map(payment => (
      <div key={payment.key} className={styles.paymentType}>
        <Button
          loading={orderLoading === `${PaymentMethodsEnum.ARCA}-${payment.key}`}
          onClick={() => orderCourse(PaymentMethodsEnum.ARCA, payment.key)}
          data_gh={`${payment.key}_gh`}
        >
          <img src={payment.image} alt={payment.title} />
        </Button>

        <div>{payment.title}</div>
      </div>
    ))}
  </div>
);

ArcaPayment.propTypes = {
  orderLoading: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  orderCourse: PropTypes.func.isRequired,
};

ArcaPayment.defaultProps = {
  orderLoading: false,
};

export default ArcaPayment;
